'use strict';
import {getLink} from '../../core-utilities/domain/ReduxUtils';
import {FORM_COLLECTION} from './config';


module.exports = function () {
  return {
    $get: [
      '$injector',
      'FirebaseUtil',
      'AuthService',
      'FirebaseConnectionService',
      'AbstractDomainClass',
      'OrgMixin',
      'FormUtils',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function (
        $injector,
        FirebaseUtil,
        AuthService,
        FirebaseConnectionService,
        AbstractDomainClass,
        OrgMixin,
        FormUtils,
        FirebaseQueueService,
        ROOT_API_COLLECTION,
        ROOT_API_SPEC,
      ) {
        function FormDomain(data) {
          AbstractDomainClass.call(this, FormDomain, data);
        }

        AbstractDomainClass.__inheritFrom(FormDomain, 'FormDomain', FORM_COLLECTION);
        OrgMixin(FormDomain);

        //TODO: versions need a custom constructor but not a full current-iteration domain class
        FormDomain.$constraints.addConstraints({
          title: {type: 'string'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          currentVersion: {type: 'string', nullable: true},

          organization: {type: 'DomainLink', domainClass: 'OrganizationDomain', belongsTo: true},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          versions: {type: 'DomainCollection', domainClass: 'FormDomain'},

          formInstances: {type: 'DomainCollection', domainClass: 'FormInstanceDomain', belongsTo: true},

          /* TODO: remove from client */
          singleFormResponses: {type: 'DomainCollection', domainClass: 'FormResponseDomain'}
        });
        // versions collection links: do not get items. domain class given just to avoid changing th library code right now.
        // The real data is stored in the meta-links collection

        // more methods go here;

        FormDomain.getVersion = getVersionStatic;
        FormDomain.getCurrentVersion = getCurrentVersionStatic;
        FormDomain.createForm = createForm;
        FormDomain.updateForm = updateForm;

        FormDomain.prototype.isEmpty = isEmpty;
        FormDomain.prototype.getVersion = getVersion;
        FormDomain.prototype.getCurrentVersion = getCurrentVersion;
        FormDomain.prototype.toString = toString;

        function createForm(form, fields) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});

          var request = {
            method: 'forms/create',
            title: form.title,
            description: form.description,
            fields: fields,
            orgId: getLink(form, 'organization').id
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC).then(function (response) {
            if (response.statusCode === 200) {
              return FormDomain.$get(response.formId)
            }
          });
        }

        function updateForm(form, fields) {
          if (!FirebaseConnectionService.online) return Promise.reject({code: 'default.error.offline.message'});

          const request = {
            ...form.$serialize(),
            method: 'forms/update',
            id: form.$id,
            fields: fields,
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        }

        function getVersionStatic(formId, versionHash) {
          return FormDomain.$getVersionsRelation(formId, versionHash).then(__hydrateVersion(versionHash));
        }

        function getCurrentVersionStatic(formId) {
          return FormDomain.$get(formId).then(__getCurrentVersion);
        }

        function getVersion(versionHash) {
          return getVersionStatic(this.$id, versionHash);
        }

        function getCurrentVersion() {
          return this.currentVersion ? getVersionStatic(this.$id, this.currentVersion) : Promise.resolve(null);
        }

        /**
         * True if this instance consists of only default values
         */
        function isEmpty() {
          return !this.title && !this.description;
        }

        function toString() {
          return this.title;
        }

        function __getCurrentVersion(form) {
          return form.getCurrentVersion();
        }

        function __hydrateVersion(hash) {
          return function __hydrateVersionCurryHash(data) {
            return {
              id: hash,
              dateCreated: new Date(data.dateCreated),
              createdBy: data.createdBy,
              fields: FormUtils.hydrate(data.fields)
            }
          }
        }

        return FormDomain;
      }]
  };
};



// WEBPACK FOOTER //
// ./src/js/forms/domain/FormDomain.js